import { Button, Card, Form, Icon, Input, Select, Spin, Tooltip, Upload } from 'antd';
import React from 'react';
import { getFormFieldByType, sanitizeFieldName } from '../../util/methods';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadFile: true,
      count: 1,
      fileList: [],
      file: null,
      loading: false,
      showUploadList: false,

      fileListFavicon: [],
      fileFavicon: null,
      moduleAccess: []
      //showUploadListFavicon: false,
    }
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    // this.props.getApplicationModules();
  }

  handleSubmit = (e) => {
    const { match, form } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      // console.log(values);
      if (err) {
        const { data } = this.props;
        if (data && data.logo) {
          if (Object.keys(err).length === 1 && Object.keys(err)[0] === 'files') {

          } else {
            return console.log(err);
          }
        } else {
          return console.log(err);
        }
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  customUpload = file => {
    this.setState(state => ({
      fileList: [file],
      file: file,
      showUploadList: true,
    }));
    return false;
  };

  customUploadFavicon = file => {
    this.setState(state => ({
      fileListFavicon: [file],
      file: file,
      showUploadList: true,
    }));
    return false;
  };

  handleChange = async info => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    this.setState({ fileList });
    if (info.file) {
      await this.getBase64(info.file, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  handleChangeFavicon = async info => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    this.setState({ fileList });
    if (info.file) {
      await this.getBase64(info.file, imageUrlFavicon =>
        this.setState({
          imageUrlFavicon,
          loading: false,
        })
      );
    }
  };

  // handleModuleSelect = (mods) => {
  //   console.log(mods);
  //   console.log(this.props.applicationModules);
  //   let access = [];
  //   mods.forEach(mod => {
  //     access = access.concat((this.props.applicationModules || []).filter(app_mod => app_mod.module === mod));
  //   })
  //   console.log(access)
  //   this.setState({
  //     moduleAccess: access
  //   })
  // }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, authUser, form } = this.props;
    const { imageUrl, imageUrlFavicon } = this.state;
    const parts = window.location.host.split('.');
    let domain = parts.slice(-2).join('.');
    if (parts.includes('qa2')) {
      domain = 'tenent.qa2.' + domain;
    }

    // const faviconID = document.getElementById("favicon");
    // if (data.favicon){
    //   //faviconID.href = "https://www.google.com/favicon.ico";
    //   faviconID.href= data.favicon;
    // }
    // else if (this.props.title ==='CREATE') {
    //   faviconID.href='https://janus-av-assets.s3.ap-south-1.amazonaws.com/assets/1632737605favicon.ico';
    // }

    const uploadButton = (
      <div>
        {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${resource}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical" autoComplete="off">
            {
              Object.keys(filters).map((item) => {
                // console.log(item)
                if (item === 'slug' && title === 'EDIT') {
                  return <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [{ required: filters[item].required, message: `${item} is required!` }],
                      initialValue: data && data['slug'],
                    })(<Input disabled />)
                    }
                  </Form.Item>;
                } else if (item === 'assetProModules') {
                  return <Form.Item key={item}
                    label=
                    {sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
                    {getFieldDecorator(item, {
                      rules: [{
                        required: true,
                        message: `Modules is required!`
                      }],
                      initialValue: (data && data[item] && data[item].length) ? data[item].map(field => field) : [],
                    })(<Select
                      // disabled={title === 'EDIT'}
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                    // onChange={this.handleModuleSelect}
                    >
                      {filters[item].options.enum.map(itm => <Select.Option key={itm}
                        value={itm}>{sanitizeFieldName(itm)}</Select.Option>)}
                    </Select>)
                    }
                  </Form.Item>
                } else if (item === 'organisationType') {
                  return <Form.Item key={item}
                    label=
                    {sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
                    {getFieldDecorator(item, {
                      rules: [{
                        required: true,
                        message: `Type is required!`
                      }],
                      initialValue: data && data[item] && data[item]['_id'],
                    })(<Select
                      // disabled={title === 'EDIT'}
                      mode="single"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                    // onChange={this.handleModuleSelect}
                    >
                      {filters[item].data.data.map(itm => <Select.Option key={itm._id}
                        value={itm._id}>{sanitizeFieldName(itm.name)}</Select.Option>)}
                    </Select>)
                    }
                  </Form.Item>
                } else if (item === 'timezone') {
                  return <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [{ required: filters[item].required, message: `${sanitizeFieldName(item)} is required!` }],
                      initialValue: (data && data[item]) || 'Asia/Kolkata',
                    })(<Select
                      disabled={title === 'EDIT'}
                      showSearch
                      style={{ width: '100%' }}
                      placeholder="Please select timezone"
                      filterOption={(input, option) =>
                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                      }
                    >
                      {moment.tz.names().map(tz =>
                        <Select.Option key={tz} value={tz}>{tz}</Select.Option>)}
                    </Select>)
                    }
                  </Form.Item>
                } else if (item === 'shortName') {
                  return <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [
                        { required: filters[item].required, message: `${sanitizeFieldName(item)} is required!` },
                        { max: 10, message: `${sanitizeFieldName(item)} must be maximum 10 characters!` }
                      ],
                      initialValue: (data && data[item]) || '',
                    })(<Input maxLength={10} />)}
                  </Form.Item>
                } else
                  return getFormFieldByType(filters, item, getFieldDecorator, data);
              })
            }
            {title === 'CREATE' ? (<>
              <Form.Item key={'user'} label="Organisation Default User">
                {getFieldDecorator('defaultUserEmail', {
                  rules: [{ required: false, message: `User Email is required!` }],
                  initialValue: ''
                })(
                  <Input disabled={title === 'EDIT'} type="email" placeholder="Default User Email"
                    autoComplete={'off'} />,
                )}
              </Form.Item>

              <Form.Item key={'password'} label="Default User Password">
                {getFieldDecorator('defaultUserPassword', {
                  rules: [{ required: false, message: `User Password is required!` }],
                  initialValue: ''
                })(
                  <Input disabled={title === 'EDIT'} type="password" placeholder="Password" autoComplete={'off'} />,
                )}
              </Form.Item>
            </>) : null
            }

            <Form.Item key={'files'} label="Upload Logo">
              {getFieldDecorator('files', {
                rules: [{ required: false, message: `Logo is required!` }],
                initialValue: (data && data['file']) ? data['file'] : []
              })(
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  name="files"
                  onChange={this.handleChange}
                  showUploadList={false}
                  beforeUpload={this.customUpload}
                  fileList={this.state.fileList}
                >
                  {imageUrl || data && data.logo ?
                    <img src={imageUrl || data.logo} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
              )}
            </Form.Item>
            <Form.Item key={'filesFavicon'} label="Favicon Icon">
              {getFieldDecorator('filesFavicon', {
                rules: [{ required: false, message: `Favicon is required!` }],
                initialValue: (data && data['favicon']) ? data['favicon'] : []
              })(
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  name="files"
                  onChange={this.handleChangeFavicon}
                  showUploadList={false}
                  beforeUpload={this.customUploadFavicon}
                  fileList={this.state.fileListFavicon}
                >
                  {imageUrlFavicon || data && data.favicon ?
                    <img src={imageUrlFavicon || data.favicon} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
              )}
            </Form.Item>

            {
              title === 'EDIT' ? <div style={{ marginBottom: '10px' }}>
                URL of Organisation: <a target="_blank"
                  href={`${window.location.protocol}//${data && data['slug']}.${domain}`}>{window.location.protocol}//{data && data['slug']}.{domain}</a>
              </div> : ''
            }

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>

        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'organisation_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
